import { Link } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { FaPhone, FaEnvelope, FaMapMarkerAlt, FaWhatsapp, FaFacebook, FaInstagram, FaLinkedin, FaIndustry } from 'react-icons/fa';
import axios from 'axios';

export default function Footer() {
  const [settings, setSettings] = useState({
    company_name: 'Polikap',
    company_address: 'Organize Sanayi Bölgesi, Ankara, Türkiye',
    company_phone: '+90 312 000 00 00',
    company_email: 'info@polikap.com.tr',
    whatsapp_number: '905320000000',
  });

  useEffect(() => {
    axios.get('/api/settings').then(r => setSettings(s => ({ ...s, ...r.data }))).catch(() => {});
  }, []);

  const links1 = [
    { to: '/', label: 'Ana Sayfa' },
    { to: '/urunler', label: 'Ürünler' },
    { to: '/hizmetler', label: 'Hizmetler' },
    { to: '/hakkimizda', label: 'Hakkımızda' },
  ];

  return (
    <footer className="bg-primary-dark text-gray-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-14">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div className="lg:col-span-2">
            <Link to="/" className="flex items-center gap-2.5 mb-4">
              <div className="w-10 h-10 bg-secondary rounded-lg flex items-center justify-center">
                <FaIndustry className="text-white text-xl" />
              </div>
              <span className="text-white font-bold text-xl">{settings.company_name}</span>
            </Link>
            <p className="text-gray-400 text-sm leading-relaxed mb-5 max-w-sm">
              Plastik ve ambalaj sektöründe yılların deneyimiyle kaliteli çözümler sunuyoruz.
              Müşteri memnuniyeti ve ürün kalitesi önceliğimizdir.
            </p>
            <div className="flex gap-3">
              {settings.whatsapp_number && (
                <a href={`https://wa.me/${settings.whatsapp_number}`} target="_blank" rel="noreferrer"
                  className="w-9 h-9 bg-green-600 hover:bg-green-500 rounded-lg flex items-center justify-center transition-colors">
                  <FaWhatsapp className="text-white" />
                </a>
              )}
              {settings.facebook_url && (
                <a href={settings.facebook_url} target="_blank" rel="noreferrer"
                  className="w-9 h-9 bg-blue-600 hover:bg-blue-500 rounded-lg flex items-center justify-center transition-colors">
                  <FaFacebook className="text-white" />
                </a>
              )}
              {settings.instagram_url && (
                <a href={settings.instagram_url} target="_blank" rel="noreferrer"
                  className="w-9 h-9 bg-pink-600 hover:bg-pink-500 rounded-lg flex items-center justify-center transition-colors">
                  <FaInstagram className="text-white" />
                </a>
              )}
              {settings.linkedin_url && (
                <a href={settings.linkedin_url} target="_blank" rel="noreferrer"
                  className="w-9 h-9 bg-blue-700 hover:bg-blue-600 rounded-lg flex items-center justify-center transition-colors">
                  <FaLinkedin className="text-white" />
                </a>
              )}
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-semibold mb-4">Hızlı Bağlantılar</h4>
            <ul className="space-y-2">
              {links1.map(l => (
                <li key={l.to}>
                  <Link to={l.to} className="text-gray-400 hover:text-secondary transition-colors text-sm flex items-center gap-2">
                    <span className="text-secondary">›</span> {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white font-semibold mb-4">İletişim</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-3 text-sm text-gray-400">
                <FaMapMarkerAlt className="text-secondary mt-0.5 flex-shrink-0" />
                <span>{settings.company_address}</span>
              </li>
              <li>
                <a href={`tel:${settings.company_phone}`} className="flex items-center gap-3 text-sm text-gray-400 hover:text-secondary transition-colors">
                  <FaPhone className="text-secondary flex-shrink-0" />
                  {settings.company_phone}
                </a>
              </li>
              <li>
                <a href={`mailto:${settings.company_email}`} className="flex items-center gap-3 text-sm text-gray-400 hover:text-secondary transition-colors">
                  <FaEnvelope className="text-secondary flex-shrink-0" />
                  {settings.company_email}
                </a>
              </li>
              {settings.whatsapp_number && (
                <li>
                  <a href={`https://wa.me/${settings.whatsapp_number}`} target="_blank" rel="noreferrer"
                    className="flex items-center gap-3 text-sm text-gray-400 hover:text-green-400 transition-colors">
                    <FaWhatsapp className="text-green-500 flex-shrink-0" />
                    WhatsApp ile Yaz
                  </a>
                </li>
              )}
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-4 py-4 flex flex-col sm:flex-row justify-between items-center gap-2 text-xs text-gray-500">
          <span>© {new Date().getFullYear()} {settings.company_name}. Tüm hakları saklıdır.</span>
          <Link to="/admin/login" className="hover:text-gray-400 transition-colors">Admin Paneli</Link>
        </div>
      </div>
    </footer>
  );
}
